import Box from '@mui/material/Box';
import Card from "@mui/material/Card";
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import TableHead from '@mui/material/TableBody';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { useTranslation } from "react-i18next";
import '../../assets/style/style.css';
import axios from "axios";
import Config from "../../config.js";
import { handleErrors } from 'common';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useState } from 'react';
import ShowTrackShipmentPopup from './components/ShowTrackShipmentPopup';
import MDTypography from "components/MDTypography";


function FulfillmentList(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const orderID = props.orderID;
  const setLoading = props.setLoading;
  const fulfillmentDetails = props.fulfilledTableData;
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [trackShipmentDetails, setTrackShipmentDetails] = useState('')
  const [showTrackShipmentDetails, setShowTrackShipmentDetails] = useState(false);

  const handleTrackShipment = async (wayBillNo) => {

    setLoading(true)
    axios({
      url: BASE + "api/order/track-shipment/" + wayBillNo,
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
    })
      .then((response) => {
        setLoading(false)
        
        if (response.status == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            setTrackShipmentDetails(response.data.data.ShipmentData[0]);
            setShowTrackShipmentDetails(true);
            
          }
          else {
            if (message != '')
              toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
          }
        }
        else {
          toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
        }
      }).catch(error => {
        console.log(error)
        setLoading(false)
        handleErrors(error, t, navigate);
      });

  }


  return (
    <>
      {fulfillmentDetails.fulfillmentItems && fulfillmentDetails.fulfillmentItems.length > 0 ?
        <>
          {fulfillmentDetails.fulfillmentItems.map((item, index) => (
            <Grid item key={index} xs={12}>

              {index === 0 ?
                <Typography color="text.secondary" sx={{ fontSize: '20px' }} pt={1} gutterBottom>
                  {t('Fulfilled Products')}
                </Typography>
                : <></>}

              <Card variant="outlined">
                <Grid item xs={12}>
                  <Grid container spacing={0}>
                    <Grid item sm={6} xs={12} px={2} py={2} display="flex">
                      <Box sx={{ border: '1px dashed grey', width: 'fit-content' }} px={1}>
                        <Typography color="text.secondary" sx={{ fontSize: '16px' }} pt={1} gutterBottom>
                          {new Date(item.fulfillmentDate).toLocaleString(undefined, { hour12: true })}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                  {fulfillmentDetails.fulfillmentRowsList[index] && fulfillmentDetails.fulfillmentRowsList[index].length > 0 ?
                    <TableContainer>
                      <Table>
                        <TableHead key={1}>
                          <TableRow key={1}>
                            {fulfillmentDetails.fulfilledColumns.map((column, index) => (
                              <TableCell key={"key-" + index}>{column.label}</TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody key={2}>
                          {fulfillmentDetails.fulfillmentRowsList[index].map((row, index) => (
                            <TableRow key={index}>
                              {fulfillmentDetails.fulfilledColumns.map((column) => (
                                <TableCell key={column.field + '-' + index}>
                                  {row[column.field]}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>

                  { item.wayBillNo ?            
                      <Grid container spacing={0}>
                        
                        <Grid item sm={8} xs={12} px={2} py={1} display="flex">
                          <Typography color="text.secondary" sx={{ fontSize: '16px' }} pt={1} gutterBottom>
                            {t("Tracking No")} : {item.wayBillNo}
                          </Typography>
                        </Grid>
                        <Grid item sm={4} xs={12} px={2} py={2} display="flex">
                          <MDTypography
                            component="a"
                            href={Config.DELHIVERY_TRACK_URL + item.wayBillNo}
                            variant="button"
                            fontWeight="bold"
                            color="info"
                            textGradient
                            target="_blank"
                            className="delhiveryLink"
                          >
                            {t('trackUrl')}
                          </MDTypography>
                          <Button
                            variant="contained"
                            className='trackShipment'
                            disableRipple
                            onClick={() => handleTrackShipment(item.wayBillNo)}
                          >
                            {t("trackShipment")}
                          </Button>
                          {showTrackShipmentDetails ?
                            <ShowTrackShipmentPopup
                              showTrackShipmentDetails={showTrackShipmentDetails}
                              setShowTrackShipmentDetails={setShowTrackShipmentDetails}
                              t={t}
                              trackShipmentDetails={trackShipmentDetails}
                            />
                            :
                            null
                          }
                        </Grid>
                      </Grid>
                  : <></> }      
                    </TableContainer>
                    : <></>}
                </Grid>
              </Card>
            </Grid>
          ))
          }
        </> : <></>}
    </>
  );
}
export default FulfillmentList;
